import React from "react";
import { useFormContext } from "react-hook-form";
/**
 * <br /> <br />
 * ## Description
 * `FormInputHidden` is a hidden input field component that allows you to include a hidden value in the form.
 */
export const FormInputHidden = (props) => {
    const { name, value } = props;
    const { register } = useFormContext();
    return React.createElement("input", Object.assign({}, register(name, { value }), { type: "hidden", "data-testid": `FormInputHidden-${name}` }));
};
